import { cn } from "@ui/lib/utils";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "@tanstack/react-router";
import { useLocale } from "@modules/shared/hooks/useLocale";

type Props = {
  isMobileView?: boolean;
  closeNavigation?: () => void;
};

const navLinks = [
  { key: "products", to: "/$locale/products" as const, segment: "products" },
  {
    key: "collections",
    to: "/$locale/collections" as const,
    segment: "collections",
  },
  { key: "blog", to: "/$locale/blog" as const, segment: "blog" },
];

export const Links: React.FC<Props> = ({ isMobileView, closeNavigation }) => {
  const { t } = useTranslation("Navbar");
  const locale = useLocale();
  const { pathname } = useLocation();

  const isActiveRoute = (segment: string) => {
    const parts = pathname.split("/").filter(Boolean);
    return parts.includes(segment);
  };

  return (
    <>
      {navLinks.map(({ key, to, segment }) => {
        const active = isActiveRoute(segment);
        return (
          <div key={key} className="group relative h-full">
            <Link
              onClick={closeNavigation}
              className={cn(
                isMobileView
                  ? "text-text-1"
                  : "flex px-4 py-5 transition-colors duration-200 dark:text-text-5",
                !isMobileView &&
                  active &&
                  "text-primary font-semibold dark:text-primary-lighter2",
                !isMobileView &&
                  !active &&
                  "hover:text-primary dark:hover:text-primary-lighter2",
                isMobileView && active && "font-semibold text-primary"
              )}
              to={to}
              params={{ locale }}
            >
              {t(key as any)}
            </Link>
            {/* Active indicator */}
            <div
              className={cn(
                "absolute bottom-3 left-1/2 h-[2px] -translate-x-1/2 rounded-full bg-primary transition-all duration-300 ease-out max-mobile:hidden",
                active ? "w-[50%] opacity-100" : "w-0 opacity-0 group-hover:w-[30%] group-hover:opacity-50"
              )}
            />
          </div>
        );
      })}
    </>
  );
};
